var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bottomView" }, [
    _c("div", { staticClass: "bottom_box" }, [
      _c("div", { staticClass: "bottom_left" }, [
        _c("div", { staticClass: "left_top" }, [_vm._v("联系我们")]),
        _vm._v(" "),
        _c("div", { staticClass: "left_item" }, [
          _c("span", { staticClass: "item_text text_1" }, [
            _c("span", { staticClass: "item_left" }, [_vm._v("客服热线：")]),
            _vm._v(
              _vm._s(_vm.pageConfig.supportPhone) +
                " (" +
                _vm._s(_vm.pageConfig.supportStaff) +
                ")"
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "item_text" }, [
            _c("span", { staticClass: "item_left" }, [_vm._v("联系地址：")]),
            _vm._v(_vm._s(_vm.pageConfig.schoolAddress))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "left_item" }, [
          _c("span", { staticClass: "item_text text_1" }, [
            _c("span", { staticClass: "item_left" }, [_vm._v("技术支持：")]),
            _vm._v(_vm._s(_vm.pageConfig.supportCompany))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "item_text" }, [
            _c("span", { staticClass: "item_left" }, [_vm._v("本站由：")]),
            _vm._v(
              _vm._s(_vm.pageConfig.supportCompany) +
                "/提供技术支持与运营服务｜粤ICP备18072307号-1"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom_right" }, [
        _vm.pageConfig.publicAccountQrCode
          ? _c(
              "div",
              {
                staticClass: "img_wrap",
                staticStyle: { "margin-right": "20px" }
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.$imgUrl + _vm.pageConfig.publicAccountQrCode,
                    alt: ""
                  },
                  on: {
                    mouseenter: function($event) {
                      _vm.showBigPublichCode = true
                    },
                    mouseleave: function($event) {
                      _vm.showBigPublichCode = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showBigPublichCode,
                      expression: "showBigPublichCode"
                    }
                  ],
                  staticClass: "img_big",
                  attrs: {
                    src: _vm.$imgUrl + _vm.pageConfig.publicAccountQrCode,
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "right_bottom" }, [
                  _vm._v("微信公众号")
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "img_wrap" }, [
          _c("img", {
            attrs: {
              src: _vm.$imgUrl + _vm.pageConfig.mobileLearnQrCode,
              alt: ""
            },
            on: {
              mouseenter: function($event) {
                _vm.showBigCode = true
              },
              mouseleave: function($event) {
                _vm.showBigCode = false
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showBigCode,
                expression: "showBigCode"
              }
            ],
            staticClass: "img_big",
            attrs: {
              src: _vm.$imgUrl + _vm.pageConfig.mobileLearnQrCode,
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "right_bottom" }, [_vm._v("移动端学习")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a351758", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a351758","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BottomView.vue
// module id = null
// module chunks = 